import styled from 'styled-components';
import { resetBtn } from 'styled-manila';
import { getColor, StyleVars, typeScale } from 'core/utils';
import Close from 'core/icons/Close';
import Button from 'core/ui/Button';
import { Textarea } from 'core/components/Form/formStyles';
import { baseText } from 'core/styles';

export const Wrapper = styled.section`
	padding: 32px 0 16px;
	border-bottom: ${({ divider }) => divider ? '1px' : '0'} solid ${getColor('alto')};

	@media(max-width: ${StyleVars.screenSm}) {
		padding-top: ${typeScale(2)};
		padding-bottom: ${typeScale(1)};
	}
`;

export const TitleRow = styled.div`
	margin-bottom: 32px;

	@media(max-width: ${StyleVars.screenSm}) {
		margin-bottom: ${typeScale(2)};
	}
`;

export const FlexContainer = styled.div`
	display: flex;
	align-items: center;
`;

export const QuestionWrapper = styled.div`
	margin-bottom: 16px;
	position: relative;
`;

export const QuestionBody = styled.p`
	${baseText}
	font-weight: 600;
	margin: 0 0 16px;
	cursor: pointer;
`;

export const AnswerListWrapper = styled.div`
	overflow: hidden;
	transition: max-height 250ms ease-out;
	max-height: 0;
`;

export const AnswerWrapper = styled.div`
	margin: 0 0 20px;

	&:first-child {
		margin: 8px 0 20px;
	}

	@media(max-width: ${StyleVars.screenSm}) {
		margin-bottom: ${typeScale(1)};
	}
`;

export const AnswerBody = styled.div`
	${baseText}
	font-size: 14px;
	font-weight: 600;
	border-left: 2px solid ${getColor('primaryBrand')};
	padding-left: 8px;
	margin-bottom: 8px;
`;

export const AnswerToggle = styled.button`
	${resetBtn}
	display: flex;
	align-items: center;
`;

export const AnswerToggleText = styled.span`
	${baseText}
	text-decoration: underline;
	color: ${getColor('cornflowerBlue')};
	font-size: 14px;
	font-weight: 600;
	margin-left: 8px;
`;

export const Author = styled.span`
	${baseText}
	display: block;
	color: ${getColor('dustyGray')};
	font-size: 12px;
	margin-top: 8px;
	font-weight: 600;
`;

export const CloseIcon = styled(Close)`
	width: 12px;
	height: 12px;
	fill: ${getColor('primaryBrand')};
`;

export const Divider = styled.hr`
	display: block;
	border: none;
	height: 1px;
	background: ${getColor('alto')};
	margin: 16px 0 0;

	@media (max-width: 620px) {
		max-width: 350px;
	}
`;

export const AnswerButton = styled(Button)`
	height: 32px;
	line-height: 28px;
	padding: 0 24px;
	margin: 16px 0 32px;
`;

export const QuestionTextarea = styled(Textarea)`
	min-height: 112px;

	@media (min-width: 1024px) {
		min-height: 112px;
	}
`;

export const AnswerForm = styled.form`
	margin-top: 32px;
`;

export const FormLabel = styled.label`
	${baseText}
	display: block;
	color: ${getColor('dustyGray')};
	font-size: 12px;
`;

export const SuccessText = styled.p`
	color: ${getColor('dustyGray')};
`;

export const HelpText = styled.p`
	color: ${getColor('dustyGray')};
	font-style: italic;
`;

export const BoldLink = styled.a`
	font-weight: 600;
`;

export const VotingContainer = styled.div`
	margin: 0 16px 16px 0;
	width: 24px;

	@media (min-width: 1270px) {
		position: absolute;
		left: -40px;
	}
`;

export const AnswerVotingContainer = styled.div`
	white-space: nowrap;
`;

export const CustomerAnswer = styled.div`
	padding-right: 16px;
`;

export const ViewAllButton = styled(Button)`
	margin-right: 16px;
	margin-bottom: 16px;
	line-height: 1;
	white-space: nowrap;
`;

export const QuestionAdminButton = styled.button`
	${resetBtn}
	margin-left: 5px;
	svg {
		max-width: none;
	}
`;

export const QuestionAdminLink = styled.a`
	margin-left: 5px;
	svg {
		max-width: none;
	}
`;
